import React, { Component } from 'react';
import { FaPlus as IconPlus } from 'react-icons/fa';
import { MdSearch as IconSearch } from 'react-icons/md';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import {
  Badge, Button, Card, CardBody, CardSubtitle, CardText, CardTitle, Col,
  Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup,
  InputGroupAddon, Label, Modal, ModalBody, ModalHeader, Row
} from 'reactstrap';
import { TextInput } from '../../lib/components/textInput';
import { TextInputButton } from '../../lib/components/textInputButton';
import { TextInputGroup } from '../../lib/components/textInputGroup';
import { SizeMe } from 'react-sizeme';


/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Object Json */
import { safeDeepGetWithType } from 'iotera-base/json';

import './style.scss';
import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const ADD = "ADD";
const WKEY = "APP_ADD";
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

const schema = {
  type: "object",
  required: ["appName", "appDomain"],
  properties: {
    appName: { type: "string", minLength: 4, maxLength: 128 },
    appDomain: { type: "string", pattern: "^[a-z][a-z0-9]{0,63}$", custom: "lalalalalaa" },
    appDesc: { type: "string" },
    appUrl: { type: "string" },
    // appTemp: { type: "string" },
  }
};

const uiSchema = {
  appName: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="appName"
          type="text"
          label="Nama aplikasi baru"
          placeholder="Masukkan nama aplikasi baru"
          textTooltip="Nama aplikasi sebagai nama dari sistem anda"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  appDomain: {
    "ui:widget": (props) => {
      return (
        <TextInputGroup
          id="appDomain"
          type="text"
          label="Domain aplikasi"
          placeholder="Masukkan domain untuk aplikasi ini"
          addonText="platform.iotera.io/"
          textTooltip="Domain aplikasi maksimal 64 karakter (huruf dan angka) tanpa spasi."
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  appDesc: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="appDesc"
          type="text"
          label="Deskripsi aplikasi"
          placeholder="Masukkan deskripsi aplikasi baru"
          textTooltip="Deskripsi berguna untuk mendeskripsikan secara singkat aplikasi baru anda"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  appUrl: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="appUrl"
          type="text"
          label="URL ke aplikasi Anda"
          placeholder="platform.iotera.io"
          textTooltip="Alamat/link dari aplikasi anda."
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  appTemp: {
    "ui:widget": (props) => {
      return (
        <TextInputButton
          id="appTemp"
          type="text"
          label="Template"
          placeholder="Pilih template untuk aplikasi ini"
          buttonModal={<ModalTemplate />}
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
};

class DropdownType extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const _this = this
    const _state = _this.state
    const { dropdownOpen } = _state
    return (
      <Dropdown style={{ display: "inline-block" }} isOpen={dropdownOpen} toggle={_this.toggle}>
        <DropdownToggle caret>
          Semua jenis
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>Semua jenis</DropdownItem>
          <DropdownItem>Smart city</DropdownItem>
          <DropdownItem>Smart factory</DropdownItem>
          <DropdownItem>Smart building</DropdownItem>
          <DropdownItem>Smart energy</DropdownItem>
          <DropdownItem>Smart agriculture</DropdownItem>
          <DropdownItem>Smart retail</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

class ModalTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalClass: ''
    }
  }

  toggle = (e, str) => {
    const _this = this
    const _state = _this.state
    const { modal } = _state
    _this.setState({
      modal: !modal,
      modalClass: str
    })
  }

  render() {
    const _this = this
    const _state = _this.state
    const { modal, modalClass } = _state
    return (
      <div>
        <Button onClick={(e) => _this.toggle(e, 'modalFadeInScale')}><IconPlus size={16} /></Button>{" "}
        <Modal size="lg" isOpen={modal} toggle={_this.toggle} className={modalClass}>
          <ModalHeader toggle={_this.toggle}>Pilih template untuk aplikasi ini</ModalHeader>
          <ModalBody>
            <Container>
              <Row style={{ marginBottom: "20px" }}>
                <div className="col-md-6"  >
                  <InputGroup>
                    <Input placeholder="Cari template" type="text" step="1" />
                    <InputGroupAddon addonType="append"><Button><IconSearch size={16} /></Button></InputGroupAddon>
                  </InputGroup>
                </div>
                <div className="col-md-6 "  >
                  <Row>
                    <div className="col-md-6 text-right" style={{ marginTop: '6px' }}  >
                      <Label>Filter</Label>
                    </div>
                    <div className="col-md-6"  >
                      <DropdownType />
                    </div>
                  </Row>
                </div>
              </Row>
              <Row>
                <div className="col-md-6"  >
                  <Card style={{ marginBottom: "10px" }}>
                    <CardBody>
                      <CardTitle className="text-center">Aplikasi baru</CardTitle>
                      <CardSubtitle>
                        <Badge color="primary" style={{ marginRight: "10px" }}>Semua jenis</Badge>
                      </CardSubtitle>
                      <CardText>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a tempor dui.
                      </CardText>
                      <Row>
                        <Col sm={6}><Button onClick={_this.toggle} color="primary" block>Pilih</Button>{" "}</Col>
                        <Col sm={6}><Button onClick={_this.toggle} color="primary" outline block>Preview</Button>{" "}</Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-md-6"  >
                  <Card style={{ marginBottom: "10px" }}>
                    <CardBody>
                      <CardTitle className="text-center">Plantera</CardTitle>
                      <CardSubtitle>
                        <Badge color="primary" style={{ marginRight: "10px" }}>Semua jenis</Badge>
                        <Badge color="primary" style={{ marginRight: "10px" }}>Smart agriculture</Badge>
                      </CardSubtitle>
                      <CardText>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a tempor dui.
                      </CardText>
                      <Row>
                        <Col sm={6}><Button onClick={_this.toggle} color="primary" block>Pilih</Button>{" "}</Col>
                        <Col sm={6}><Button onClick={_this.toggle} color="primary" outline block>Preview</Button>{" "}</Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
                <div className="col-md-6"  >
                  <Card style={{ marginBottom: "10px" }}>
                    <CardBody>
                      <CardTitle className="text-center">TSR</CardTitle>
                      <CardSubtitle>
                        <Badge color="primary" style={{ marginRight: "10px" }}>Semua jenis</Badge>
                        <Badge color="primary" style={{ marginRight: "10px" }}>Smart energy</Badge>
                      </CardSubtitle>
                      <CardText>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a tempor dui.
                      </CardText>
                      <Row>
                        <div className="col-md-6"  >
                          <Button onClick={_this.toggle} color="primary" block>Pilih</Button>{" "}
                        </div>
                        <div className="col-md-6"  >
                          <Button onClick={_this.toggle} color="primary" outline block>Preview</Button>{" "}
                        </div>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </Row>
            </Container>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

class ApplicationAdd extends Component {
  constructor(props) {
    super(props);
    let widthImage;
    let paddingStyle = '6px 8px';
    let padForm = '0px';
    if (window.innerWidth >= 425) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          paddingStyle = '12px 16px';
          widthImage = '60%';
        } else {
          widthImage = '80%';
        }
        padForm = '17.5px';
      } else {
        widthImage = '30%';
      }
    } else {
      widthImage = '50%';
    }
    this.state = {
      file: 'https://i.imgur.com/8FWamdx.jpg',
      files: [],
      activeTab: '1',
      formData: {},
      loading: false,
      custom: window.innerWidth <= 768 ? "col-sm-6" : "col-sm-12",
      percent: window.innerWidth >= 768 ? '40%' : '80%',
      widthImage,
      padForm,
      paddingStyle
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.testClick = this.testClick.bind(this)
    this.dismissLoading = this.dismissLoading.bind(this)
    this.resize = this.resize.bind(this);
    this.onRemovePicture = this.onRemovePicture.bind(this);
  }

  resize(event) {
    let widthImage;
    let paddingStyle = '6px 8px';
    let padForm = '0px';
    if (window.innerWidth >= 425) {
      if (window.innerWidth >= 768) {
        if (window.innerWidth >= 1200) {
          paddingStyle = '12px 16px';
          widthImage = '60%';
        } else {
          widthImage = '80%';
        }
        padForm = '17.5px';
      } else {
        widthImage = '30%';
      }
    } else {
      widthImage = '50%';
    }
    this.setState({
      custom: window.innerWidth <= 768 ? "col-sm-6" : "col-sm-12",
      percent: window.innerWidth >= 768 ? '40%' : '80%',
      widthImage,
      padForm,
      paddingStyle
    })
  }

  handleChange(event) {
    if (event.target.files.length > 0) {
      this.setState({
        file: URL.createObjectURL(event.target.files[0])
      })
    }
  }

  testClick() {
    const _this = this
    setTimeout(() =>
      _this.setState({ loading: true })
      , 0)
    setTimeout(() =>
      _this.dismissLoading(), 3000);
  }

  dismissLoading() {
    setTimeout(() =>
      this.setState({ loading: false })
      , 1500)
  }

  getFiles(files) {
    this.setState({ files: files })
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    let submitData = event['formData'];
    const name = safeDeepGetWithType(submitData, ['appName'], '');
    const domain = safeDeepGetWithType(submitData, ['appDomain'], '');
    const description = safeDeepGetWithType(submitData, ['appDesc'], '');
    _this.setState({
      formData: submitData,
      loading: true
    })
    if (description === '') {
      _props.wSingleRequestCall({
        id: ADD,
        body: {
          name,
          domain
        }
      });
    } else {
      _props.wSingleRequestCall({
        id: ADD,
        body: {
          name,
          domain,
          description
        }
      });
    }
  }

  toggle(tab) {
    const _this = this
    const _state = _this.state
    const { activeTab } = _state
    if (activeTab !== tab) {
      _this.setState({
        activeTab: tab
      });
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/add",
            timeout: 180000
          },
          wcallback: {
            finished: function (id, result) {
              _this.setState({
                loading: false
              })
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _props.history.push('.' + S + 'list')
                  _props.showSingleNotification({ message: 'Tambah Aplikasi Sukses', level: 'success' });
                  return;
                }
              } else if (result.code === Result.HTTP.BAD_REQUEST) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -2) {
                  _props.showSingleNotification({ message: 'Domain harus alphanumerik dan tidak diawali angka', level: 'warning' });
                  return;
                } else if (responseResult === -3) {
                  _props.showSingleNotification({ message: 'Domain sudah terpakai, silahkan gunakan domain lain', level: 'warning' });
                  return;
                }
              }
              _props.showSingleNotification({ message: 'Tambah Aplikasi Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ single_config: WKEY });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  onRemovePicture() {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus gambar ini?',
      'Ya, hapus',
      () => this.setState({
        file: 'https://i.imgur.com/8FWamdx.jpg'
      }),
      null,
      null
    )
  }

  render() {
    const _this = this
    const _state = _this.state
    window.onresize = _this.resize;
    const { loading, paddingStyle, formData, widthImage, file } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let dataToShow = {};
    if (formData === {}) {
      dataToShow = {}
    } else {
      dataToShow = formData;
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah aplikasi' subTitle='Permohonan tambah aplikasi baru' />
          <div className="view-content-dashboard" >
            <Row style={{ margin: 0 }}>
              <div className="col-md-4" style={{ paddingRight: 0, paddingLeft: 0 }} >
                <SizeMe >{({ size }) =>
                  <Card className="cobaForm"
                    style={{
                      marginTop: 0, minWidth: widthImage, maxWidth: widthImage,
                      height: size.width * 4 / 4, maxHeight: size.width * 4 / 4
                    }}>
                    <CardBody style={{ margin: 20 }}>
                      <div className="containers" style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
                        <Card className="cardssss" style={{ backgroundColor: '#ffffff', mindWidth: '100%', minHeight: '100%' }}>
                          <CardBody >
                            <Row >
                              <img src={file} alt="Profile"
                                style={{
                                  minHeight: '100%', maxHeight: '100%', minWidth: '100%',
                                  position: 'absolute', top: 0, left: 0, bottom: 0, right: 0
                                }} />
                            </Row>
                          </CardBody>
                        </Card>
                        {file === 'https://i.imgur.com/8FWamdx.jpg' ?
                          <div className="middle">
                            <Row >
                              <div className="col-md-12">
                                <label className="button-iotera-primary-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}>
                                  <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                  <span>Unggah</span>
                                </label>
                              </div>
                            </Row>
                          </div> :
                          <div className="middle">
                            <Row style={{ marginBottom: 5 }}>
                              <div className="col-md-12">
                                <label className="button-iotera-primary-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}>
                                  <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                  <span>Ganti</span>
                                </label>
                              </div>
                            </Row>
                            <Row>
                              <div className="col-md-12">
                                <button className="button-iotera-red-outline text"
                                  style={{ padding: paddingStyle, marginBottom: 0 }} onClick={(e) => _this.onRemovePicture()} >
                                  Hapus
                                </button>
                              </div>
                            </Row>
                          </div>
                        }
                      </div>
                    </CardBody>
                  </Card>}
                </SizeMe>
              </div>
              <div className="col-md-8" style={{ paddingRight: 0, paddingLeft: 0 }} >
                <IoteraForm
                  schema={schema}
                  uiSchema={uiSchema}
                  onSubmit={_this.handleSubmit}
                  formData={dataToShow}
                >
                  <div className="button-right" style={{ marginTop: 10 }}>
                    <button className="button-iotera-white" type="button"
                      style={{ minWidth: '0%' }} onClick={(e) => _this.goTo('.' + S + 'list')} >Batal</button>
                    <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
                  </div>
                </IoteraForm>
              </div>
            </Row>
          </div>
        </div>
      </Loader>
    );
  }
}


const mapStateToProps = function (state) {
  return {
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ApplicationAdd));